import { TextCell } from '@common/components/TextCell';

interface FinanceAndInsuranceProfitCellProps {
	profit?: string;
}

export const FinanceAndInsuranceProfitCell = ({ profit }: FinanceAndInsuranceProfitCellProps) => {
	return <TextCell value={profit} weight='semibold' />;
};
